// let theme = window.theme || {};
import Swiper, { Navigation, Pagination, Thumbs, A11y, Keyboard } from 'swiper';

let product_carousels = null;
let product_thumbs = {};
let quickview_carousels = null;
let quickview_thumbs = {};

const initProductCarousel = (carousel) => {
  const container = carousel.closest('[data-section-type="product"]');
  const editCartItemContainer = carousel.closest('.CartEditItem');
  const slides_main = container.querySelectorAll('[data-product-images-slide]');
  const is_quickview = carousel.getAttribute('quick-view-carousel');

  if (slides_main.length <= 1) {
    return;
  }

  const thumb_id = container.querySelector('[data-product-images-thumbs-wrapper]').getAttribute('id');
  const thumb_number = container.querySelector('[data-thumb-count]').getAttribute('data-thumb-count');
  const isQuickview = container.closest('.ProductGrid').parentNode.dataset.sectionId === 'QuickView';
  // if data-product-video-data.textContent is not {} then hasVideos is true, but whitespace should be trimmed
  const videoData = container.querySelector('[data-product-video-data]');
  const hasVideos = videoData ? JSON.parse(videoData.textContent).videos?.length > 0 : false;

  if (product_carousels && !isQuickview) {
    product_carousels.detachEvents();
  }

  // We must set a spaceBetween value to Swiper when you're using Quick Shop in the site
  // Quick Shop is a little different on the cart page.
  let spaceBetweenValue = isQuickview ? 10 : 18;
  if (editCartItemContainer) {
    spaceBetweenValue = 8;
  }

  // Initialize thumbnails
  const swiperThumbs = new Swiper(`#${thumb_id} .swiper-thumbs`, {
    modules: [Navigation, A11y, Keyboard],
    direction: 'vertical',
    slidesPerView: 4,
    slideToClickedSlide: true,
    autoHeight: false,
    threshold: 11,
    a11y: {
      enabled: true,
      containerMessage: 'Product thumbnails',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
    },
    keyboard: {
      enabled: true,
    },
    spaceBetween: spaceBetweenValue,
    navigation: {
      nextEl: '.swiper-button-thumbs.swiper-button-next',
      prevEl: '.swiper-button-thumbs.swiper-button-prev',
    },
    on: {
      init: function () {
        document.querySelector(`[data-thumb-count="${thumb_number}"] .swiper-buttons`).classList.add('initialized');
      },
      click: function (swiper, event) {
        swiper.visibleSlides.forEach((s) => {
          if (s.style.display !== 'none') return true;
          if (!s.querySelector('.icon-play')) return true;
          s.remove();
          swiper.updateSlides();
        });
        setTimeout(() => {
          if (!event.target.closest('.swiper-slide').classList.contains('swiper-slide-thumb-active')) {
            const mainSwiper = event.target.closest('.ProductImages__Wrapper')?.querySelector('.swiper-main')?.swiper;

            if (mainSwiper && typeof swiper.clickedIndex != 'undefined') {
              swiper.update();
              mainSwiper.slideTo(swiper.clickedIndex);
              mainSwiper.update();
            }
          }
        }, 5);
      },
    },
  });

  let swiperInstance;

  swiperInstance = new Swiper('.swiper-main', {
    modules: [Navigation, Pagination, Thumbs, A11y, Keyboard],
    touchMoveStopPropagation: false,
    slidesPerView: 'auto',
    centeredSlides: false,
    watchOverflow: true,
    preventInteractionOnTransition: true,
    loop: isQuickview && !hasVideos, // Enable loop only for QuickView without videos
    pagination: {
      el: '#ProductCarousel .swiper-pagination,.ProductImages .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    thumbs: {
      swiper: swiperThumbs,
    },
    breakpoints: {
      767: {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        touchMoveStopPropagation: true,
        loop: false,
      },
    },
    on: {
      init: function () {
        this.update();
        this.loopFix();
      },
      slideChange: function () {
        // Remove the active class from all thumbnails
        document.querySelectorAll('.ProductImages__thumbs-placeholder.swiper-slide').forEach((slide) => {
          slide.classList.remove('swiper-slide-thumb-active');
        });

        // Add the active class to the currently active thumbnail
        const thumbnails = document.querySelectorAll('.ProductImages__thumbs-placeholder.swiper-slide');
        if (thumbnails[this.activeIndex]) {
          thumbnails[this.activeIndex].classList.add('swiper-slide-thumb-active');
        }
      },
      snapIndexChange: function (swiper) {
        document.querySelectorAll('.swiper-pagination-bullet').forEach((bullet, index) => {
          const slideIndex = swiper.loopedSlides ? swiper.realIndex : swiper.snapIndex;
          bullet.classList.toggle('swiper-pagination-bullet-active', index === slideIndex);
        });
      },
    },
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous slide',
      containerMessage: 'Main product carousel',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
    },
    keyboard: {
      enabled: true,
    },
  });

  document.querySelectorAll('[data-custom-variant-selector]').forEach((element) => {
    element.addEventListener('click', function () {
      swiperThumbs.update();
    });
  });

  document.querySelectorAll(`#${thumb_id} .swiper-thumbs .swiper-slide`).forEach((thumb, index) => {
    thumb.setAttribute('tabindex', '0');

    thumb.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        swiperInstance.slideTo(index);
      }
    });
  });

  if (!is_quickview) {
    product_carousels = swiperInstance;
  }
};

const initProductCarousels = (type) => {
  const carousel = document.querySelector('[data-product-images-carousel]');

  initProductCarousel(carousel);

  const event = new CustomEvent('productOverviewCarouselsDidInit', {
    detail: {
      carousels: type === 'QuickView' ? quickview_carousels : product_carousels,
      thumbs: type === 'QuickView' ? quickview_thumbs : product_thumbs,
    },
  });
  document.dispatchEvent(event);
};

export {
  product_carousels,
  product_thumbs,
  quickview_carousels,
  quickview_thumbs,
  initProductCarousel,
  initProductCarousels,
};
